import { AppContentStatus } from '../../../config/AppContentStatus';
import { useTranslation } from 'react-i18next';

const ContentStatusNotification = () => {
  // On désactive complètement les notifications
  return null;
};

export default ContentStatusNotification;
